export const MDP_Request_data_Form_prod =
	"https://forms.office.com/Pages/ResponsePage.aspx?id=BVzXBRr650Kc8etBbDlvLZ2Vt0Cd8vRKjdUFQ4E7ra5UQU5VNjJZMFBXNTVYVVRQNVFEMU5JWVMwSC4u";
export const MDP_Request_data_Form_dev =
	"https://forms.office.com/Pages/ResponsePage.aspx?id=BVzXBRr650Kc8etBbDlvLZ2Vt0Cd8vRKjdUFQ4E7ra5UNzNTQ0UwT1NMTkM3OU4yNDlUWklaUU1BMS4u";

export const AZURE_DEVOPS_data_Form_prod =
	"https://forms.office.com/Pages/ResponsePage.aspx?id=BVzXBRr650Kc8etBbDlvLZ2Vt0Cd8vRKjdUFQ4E7ra5UNjdRTjVFOVZMTlYxQjlFQ1o1TTU2VjZURy4u";
export const INFRA_STRUCTURE_data_Form_prod =
	"https://forms.office.com/Pages/ResponsePage.aspx?id=BVzXBRr650Kc8etBbDlvLZ2Vt0Cd8vRKjdUFQ4E7ra5URFJFSjBMTkcwRExYUVZEWDhOTlI3SkYxVS4u";
export const DATA_LAKE_data_Form_prod =
	"https://forms.office.com/Pages/ResponsePage.aspx?id=BVzXBRr650Kc8etBbDlvLZ2Vt0Cd8vRKjdUFQ4E7ra5URUlUSDNVMDg2U1BJS1RRTkdBMzRPMk02Ri4u";
export const CENTRAL_METASTORE_data_Form_prod =
	"https://forms.office.com/Pages/ResponsePage.aspx?id=BVzXBRr650Kc8etBbDlvLZ2Vt0Cd8vRKjdUFQ4E7ra5UOVFCOVdBVldMS1YxR00zNEU0SUtDTk9DMC4u";
export const DATA_ACCESSAPI_data_Form_prod =
	"https://forms.office.com/Pages/ResponsePage.aspx?id=BVzXBRr650Kc8etBbDlvLZ2Vt0Cd8vRKjdUFQ4E7ra5UOUM5TlFMRDIyRTUwN1pTV0tJOTMxMUpQVy4u";

export const AZURE_DEVOPS_data_Form_dev =
	"https://forms.office.com/Pages/ResponsePage.aspx?id=BVzXBRr650Kc8etBbDlvLZ2Vt0Cd8vRKjdUFQ4E7ra5UNTJKU0ZHMUpET1VPT0ZKREZMNVdOWlkzUi4u";
export const INFRA_STRUCTURE_data_Form_dev =
	"https://forms.office.com/Pages/ResponsePage.aspx?id=BVzXBRr650Kc8etBbDlvLZ2Vt0Cd8vRKjdUFQ4E7ra5UNFU1Nko3OVhXUzZSNjNZNlBQVTdLOURNQS4u";
export const DATA_LAKE_data_Form_dev =
	"https://forms.office.com/Pages/ResponsePage.aspx?id=BVzXBRr650Kc8etBbDlvLZ2Vt0Cd8vRKjdUFQ4E7ra5UMktMNEY5M0tSS0NGVzBQNklZU1Y5SjVVQS4u";
export const CENTRAL_METASTORE_data_Form_dev =
	"https://forms.office.com/Pages/ResponsePage.aspx?id=BVzXBRr650Kc8etBbDlvLZ2Vt0Cd8vRKjdUFQ4E7ra5UQ08xUVU1UUIxNFRXS0ZVSTY2R1JCOEdXOS4u";
export const DATA_ACCESSAPI_data_Form_dev =
	"https://forms.office.com/Pages/ResponsePage.aspx?id=BVzXBRr650Kc8etBbDlvLZ2Vt0Cd8vRKjdUFQ4E7ra5UQ1NKQVlaM1RIODg1VkI1Mk0xN00zMkRZRS4u";
